import { useTranslation } from 'react-i18next'

const MobileRestrictionCard = () => {
  const { t } = useTranslation()

  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-6"
      style={{ zIndex: 9999 }}
    >
      {/* Overlay avec blur */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

      {/* Card */}
      <div className="relative bg-white rounded-lg shadow-lg p-8 max-w-md text-center">
        <div className="mb-4">
          <svg
            className="mx-auto h-12 w-12 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-3">
          {t('webApp.mobileRestriction.title')}
        </h2>
        <p className="text-gray-600">
          {t('webApp.mobileRestriction.description')}
        </p>
      </div>
    </div>
  )
}

export default MobileRestrictionCard
